import { useQuery } from "@tanstack/react-query";

import { isAutomationActive } from "@/features/records/automationStatusUtil";
import { getJob, type JobDetailOut } from "@/lib/api/jobs";

/** Job 자체가 active 거나, 파일 중 처리 미완 상태가 남아 있으면 폴링 유지.
 *  cancelling 은 중지 마감(cancelled)까지 폴링 유지. */
const ACTIVE_JOB = new Set(["pending", "processing", "cancelling"]);
const ACTIVE_FILE = new Set(["pending", "processing", "ocr_done"]);

export const jobDetailKey = (jobId: string) => ["jobs", jobId] as const;

export function useJobDetail(jobId: string | undefined) {
  return useQuery<JobDetailOut>({
    queryKey: jobDetailKey(jobId ?? ""),
    queryFn: () => {
      if (!jobId) throw new Error("jobId is required");
      return getJob(jobId);
    },
    enabled: !!jobId,
    refetchInterval: (query) => {
      const data = query.state.data;
      if (!data) return 3000;
      if (ACTIVE_JOB.has(data.status)) return 3000;
      if (data.files.some((f) => ACTIVE_FILE.has(f.status))) return 3000;
      // M21 #7 — 최종 AI 검토가 백그라운드로 도는 동안 폴링 유지.
      if (
        data.files.some((f) => {
          const r = f.record;
          return !!r && r.review_status === "human_done" && r.ai_review == null;
        })
      ) {
        return 3000;
      }
      // M26 — 자동 검수가 대기·진행 중인 건이 있으면 폴링 유지.
      if (data.files.some((f) => isAutomationActive(f.record))) return 3000;
      return false;
    },
  });
}
